import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getSettings } from "../lib/api";

// Phase 14 STEP 3.4 — identité légale settings-driven (données RÉELLES, jamais traduites).
const DEFAULTS = {
  editor_name: "ITERCATUS",
  legal_form: "Association loi 1901",
  address: "Quartier les 3 fonds, 13124 Peypin",
  rna: "W133042393",
  siren: "103700357",
  email: "dpo@itercatus.fr",
  publication_director: "Gilles Fouque",
  publication_director_role: "Président",
  host: "FastComet",
};

export default function LegalPage() {
  const { t } = useTranslation();
  const [L, setL] = useState(DEFAULTS);
  const P = t("pages.legal", { returnObjects: true });

  useEffect(() => {
    getSettings()
      .then((res) => setL({ ...DEFAULTS, ...(res?.data?.legal_mentions || {}) }))
      .catch(() => setL(DEFAULTS));
  }, []);

  return (
    <div className="min-h-screen bg-secondary pt-20" data-testid="legal-page">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-12 md:py-16">
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-primary mb-8">{P.title}</h1>
        <div className="bg-white border border-border rounded-lg p-6 md:p-8 prose prose-primary max-w-none">
          <h2>{P.editorH}</h2>
          {(P.intro || []).map((p, i) => <p key={i}>{p}</p>)}
          <ul data-testid="legal-identity">
            {L.editor_name && <li><strong>{P.labels.denomination} :</strong> {L.editor_name}</li>}
            {L.legal_form && <li><strong>{P.labels.form} :</strong> {L.legal_form}</li>}
            {L.address && <li><strong>{P.labels.hq} :</strong> {L.address}</li>}
            {L.rna && <li><strong>{P.labels.rna} :</strong> {L.rna}</li>}
            {L.siren && <li><strong>{P.labels.siren} :</strong> {L.siren}</li>}
            {L.email && <li><strong>{P.labels.email} :</strong> <a href={`mailto:${L.email}`}>{L.email}</a></li>}
          </ul>

          {(L.publication_director || L.host) && <h2>{P.directorH}</h2>}
          {L.publication_director && (
            <>
              <p>{P.directorLead}</p>
              <p>
                <strong>{L.publication_director}</strong>
                {L.publication_director_role ? <>, {P.directorRolePrefix} <strong>{L.publication_director_role}</strong></> : null}
              </p>
            </>
          )}
          {L.host && (<><h2>{P.hostH}</h2><p>{P.hostPrefix} <strong>{L.host}</strong></p></>)}

          {(P.blocks || []).map((b, i) => (
            <div key={i}>
              <h2>{b.h}</h2>
              {(b.p || []).map((p, j) => <p key={j}>{p}</p>)}
            </div>
          ))}

          <p className="text-sm text-muted-foreground" data-testid="legal-fr-prevails"><em>{t("pages.frPrevails")}</em></p>
        </div>
      </div>
    </div>
  );
}
